import { useHookstate } from "@hookstate/core";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useAnnouncementsCount = () => {
    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
    const { getAnnouncementsData } = useSelector((state) => state.commonReducers) || [];
    const [announcementsCount, setAnnouncementsCount] = useState(0);

    useEffect(() => {
        if (siteId.get() !== null) {
            let dismissedIds = [];
            const dismissedIdsString = localStorage.getItem("dismissedIds");
            if (dismissedIdsString) {
                dismissedIds = JSON.parse(dismissedIdsString);
            }

            let count = 0;
            if (
                getAnnouncementsData &&
                getAnnouncementsData?.Messages &&
                getAnnouncementsData?.Messages?.length !== 0
            ) {
                // Only count announcements that haven't been dismissed
                count = getAnnouncementsData.Messages.filter(
                    (item) => !item.IsAcknowledged && !dismissedIds.includes(item.Id)
                ).length;
            }
            setAnnouncementsCount(count);
        } else {
            setAnnouncementsCount(0);
        }
    }, [getAnnouncementsData, siteId.get(), localStorage.getItem("dismissedIds")]);

    return { announcementsCount };
};

export default useAnnouncementsCount;
